import { useQuery } from "@apollo/client";
import HeroTile from "../components/HeroTile";
import PortraitTile from "../components/PortraitTile";
import FeaturedEventsTile from "../components/FeaturedEventsTile";
import BioTile from "../components/BioTile";
import SocialLinksTile from "../components/SocialLinksTile";
import { GET_EVENTS } from "../graphql/queries";
import { Event } from "../types";

function Home() {
  const { data, loading, error } = useQuery<{ events: Event[] }>(GET_EVENTS);

  if (error) {
    return <p className="body-text">Error loading events: {error.message}</p>;
  }

  return (
    <div className="bentolio-grid">
      <HeroTile />
      <PortraitTile
        src="/images/Cover2.jpg"
        alt="Kate's birthday celebration decor collage"
      />
      <FeaturedEventsTile events={data?.events ?? []} loading={loading} />
      <BioTile />
      <PortraitTile
        src="/images/Cover1.jpg"
        alt="Bubble show performance at a children's event"
        area="contact"
      />
      <SocialLinksTile />
    </div>
  );
}

export default Home;
